<template>
  <div class="payment-window">
    <HUILoadingView v-if="!loaded" absolute />
    <iframe
      :class="iframeClassObject"
      :src="paymentLink.url"
      @load="loaded = true"
      class="payment-window__iframe"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import { HUILoadingView } from '@/halifax-ui'

export default {
  components: {
    HUILoadingView
  },
  props: {
    paymentLink: {
      type: Object,
      required: true,
      validator: value => typeof value.url === 'string' && typeof value.payment_id === 'number'
    },
    orderToken: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loaded: false
    }
  },
  computed: {
    iframeClassObject() {
      return { 'payment-window__iframe--visible': this.loaded }
    }
  },
  created() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(event) {
      // Only listen for events from same origin
      if (event.origin !== window.location.origin) {
        return
      }
      try {
        const { status } = JSON.parse(event.data)
        const strategy = {
          continue: this.handleContinue,
          cancel: this.handleCancel
        }
        strategy[status] && strategy[status]()
      } catch (error) {
        // event.data was not json - do nothing
      }
    },
    async handleContinue() {
      try {
        await this.$store.dispatch('order/REGISTER_PAYMENT', {
          orderToken: this.orderToken,
          price: this.paymentLink.price,
          paymentId: this.paymentLink.payment_id
        })
        this.$emit('complete')
      } catch (error) {
        this.$emit('failed', error)
      }
    },
    handleCancel() {
      this.$emit('aborted')
    }
  }
}
</script>

<style lang="scss">
@import '~@/halifax-ui/src/scss/framework';
@import '~@/scss/variables';

.payment-window {
  position: relative;
  display: flex;
  width: 100%;
  height: calc(100vh - #{$height-modal-vc-header});
  background: #fff;

  @include supports-safe-area-insets {
    height: calc(100vh - #{$height-modal-vc-header} - var(--safe-area-inset-top));
  }

  &__iframe {
    display: block;
    height: 100%;
    width: 100%;
    opacity: 0;

    &--visible {
      opacity: 1;
    }
  }
}
</style>
